import script from "./OrderEditChargeback.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderEditChargeback.vue?vue&type=script&setup=true&lang=js"

import "./OrderEditChargeback.vue?vue&type=style&index=0&id=1cb3d664&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb3d664"]])

export default __exports__